import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { SimpleCandidateModule } from '@shared/simple-candidate/simple-candidate.module';

import { PdfViewerAdapterModule } from '../pdf-viewer-adapter/pdf-viewer-adapter.module';
import { PdfPreviewTooltipComponent } from './pdf-preview-tooltip.component';
import { MatDialogModule } from '@angular/material/dialog';
import { CandidatePdfPreviewComponent } from './candidate-pdf-preview/candidate-pdf-preview.component';

@NgModule({
  declarations: [PdfPreviewTooltipComponent, CandidatePdfPreviewComponent],
  imports: [
    CommonModule,
    MatMenuModule,
    MatIconModule,
    PdfViewerAdapterModule,
    MatProgressSpinnerModule,
    SimpleCandidateModule,
    MatDialogModule,
  ],
  exports: [PdfPreviewTooltipComponent, CandidatePdfPreviewComponent],
})
export class PdfPreviewTooltipModule {}
